export const microAppsHiddenLivePlugin = {
  beforeBootstrap() {
    const QUERY_PARAM_REGEX = /cpAppsVersions\[.+\]/;
    new URLSearchParams(window.location.search).forEach((value, key) => {
      if (!key.match(QUERY_PARAM_REGEX)) {
        return;
      }
      sessionStorage.setItem(key, value);
    });
  },
};
